module.exports = __webpack_public_path__ + "img/yiqi1.52956cf1.png";